import { Result } from '../../../../../common/models/Result';
import { HttpServiceBase } from '../../../../../common/services/HttpServiceBase';

export class ExchangePointsRewardService extends HttpServiceBase {

  handle = (input: ExchangePointsRewardInput, bearerToken: string): Promise<Result<ExchangePointsRewardOutput> | null> => {
    const promise = this.http.post<Result<ExchangePointsRewardOutput>, ExchangePointsRewardInput>(
      `${this.baseUrlZerezesApi}/club-pdv/member-account-reward-exchange/${input.shopifyCustomerId}`,
      input,
      false,
      bearerToken
    );
    return promise;
  }
}

export class ExchangePointsRewardInput {
  shopifyCustomerId: number;
  rewardId: number;
  source: string;
}

export class ExchangePointsRewardOutput {
  success: boolean;
  couponCode?: string;
  couponExpiresAt: Date | null;
  formattedCouponExpirationDate?: string;
  errorMessage?: string;
  errorType?: number | null;
}